import './styles/index.scss';
import './scripts/index.js';